import * as React from 'react'
import {useStaticQuery, graphql} from 'gatsby'

import RenderRichText from 'src/utils/renderRichText'
import ElevatedCard from 'src/components/molecules/ElevatedCard'
import {Box} from '@mui/material'

const BenchmarkBannerSection = () => {
  const {
    prismicBenchmarkBox: {data},
  } = useStaticQuery(graphql`
    {
      prismicBenchmarkBox {
        data {
          body_text {
            richText
          }
          title {
            richText
          }
        }
      }
    }
  `)
  return (
    <ElevatedCard centered overlapTop>
      <Box
        sx={{
          '& p': {
            mb: 0,
          },
        }}
      >
        <RenderRichText field={data.title} />
        <RenderRichText field={data.body_text} />
      </Box>
    </ElevatedCard>
  )
}

export default BenchmarkBannerSection
